import { render, staticRenderFns } from "./roomInfo.vue?vue&type=template&id=1bc85056&scoped=true"
import script from "./roomInfo.vue?vue&type=script&lang=js"
export * from "./roomInfo.vue?vue&type=script&lang=js"
import style0 from "./roomInfo.vue?vue&type=style&index=0&id=1bc85056&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc85056",
  null
  
)

export default component.exports